import { requestGooseAPI, getAPIPath } from '../shared/request'
import { ReportClientDto, CLIENT_REPORTS_PATH } from '../types'

export type TClientReportsServiceOptions = {
  filter: {
    startDate?: string
    endDate?: string // is exclusive
    interval?: 'DAY' | 'WEEK' | 'MONTH' | 'YEAR'
    date?: string
    isRange?: boolean
    locationUserProfile?: string
  }
}

export const ClientReportsService = {
  get: async (
    locationName: string,
    lupId: string,
    reportName: string,
    options: TClientReportsServiceOptions
  ): Promise<ReportClientDto> => {
    return requestGooseAPI<ReportClientDto>({
      url: getAPIPath(CLIENT_REPORTS_PATH, { locationId: locationName, lupId, reportName }),
      method: 'GET',
      params: {
        ...(options.filter.isRange
          ? { startDate: options.filter.startDate, endDate: options.filter.endDate, interval: options.filter.interval }
          : { date: options.filter.date }),
      },
    })
  },
}
